/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the sheet tabs and your baseline total before editing. Select a formula cell and inspect its formula bar, rather than checking only the number displayed in the grid.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑前，核对工作表标签和基准合计。选中公式单元格查看公式栏，不要只看网格中显示的数字。`)
};

/**
* | output |
* | --- |
* | "Check the sheet tabs and your baseline total before editing. Select a formula cell and inspect its formula bar, rather than checking only the number displaye..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_1 as "gc.search_guides.gridcraft_excel_compatibility.sections.1.steps.1" }